import { render, staticRenderFns } from "./LoadingLayoutSchema.vue?vue&type=template&id=48f8d5d1&"
import script from "./LoadingLayoutSchema.vue?vue&type=script&lang=ts&"
export * from "./LoadingLayoutSchema.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingLayoutSchema.vue?vue&type=style&index=0&id=48f8d5d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports